// extracted by mini-css-extract-plugin
module.exports = {"container":"EmailActivation_container__2ais4","logoContainer":"EmailActivation_logoContainer__19LiZ","spinnerContainer":"EmailActivation_spinnerContainer__3sY19"};